// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let Klarna: any;

/**
 * Fetch klarna script
 * Sets store.teliaPayReady when telia pay script function is loaded on window
 *
 * Only use in onMounted lifecycle hook
 */
export const useFetchKlarnaScript = () => {
  const checkoutStore = useMyCheckoutStore();
  const CHECK_FOR_KLARNA_INIT_FUNCTION__INTERVAL_MS = 200;
  const MAX_CHECK_FOR_KLARNA_TIME__MS = 5000;
  let checkIfKlarnaInitFunctionExistsTimer: NodeJS.Timeout;

  const hasSetKlarnaScript: Ref<boolean> = ref(false);

  const fetchKlarnaScript = async () => {
    try {
      if (Klarna && Klarna?.Payments?.init !== undefined) {
        hasSetKlarnaScript.value = true;
        return;
      }
    } catch (e) {
      if (hasSetKlarnaScript.value === false) {
        useHead({
          script: [
            {
              src: 'https://x.klarnacdn.net/kp/lib/v1/api.js',
              tagPosition: 'bodyClose',
              crossorigin: 'anonymous',
            },
          ],
        });
      }
    }

    checkIfKlarnaInitFunctionExistsTimer = setInterval(() => {
      try {
        if (Klarna?.Payments?.init !== undefined) {
          hasSetKlarnaScript.value = true;
        }
      } catch (e) {
        // Klarna SDK not found in the browser yet, no need to do anything
      }
    }, CHECK_FOR_KLARNA_INIT_FUNCTION__INTERVAL_MS);

    watch(hasSetKlarnaScript, (value: boolean) => {
      if (value) {
        clearInterval(checkIfKlarnaInitFunctionExistsTimer);
        checkoutStore.ui.klarnaReady = true;
      }
    });

    setTimeout(() => {
      clearInterval(checkIfKlarnaInitFunctionExistsTimer);
    }, MAX_CHECK_FOR_KLARNA_TIME__MS);

    onUnmounted(() => {
      clearInterval(checkIfKlarnaInitFunctionExistsTimer);
    });
  };

  return {
    fetchKlarnaScript,
    hasSetKlarnaScript,
  };
};
